class MenuTabs extends HTMLElement {
  constructor() {
    super();
    this.handleTabClick = this.handleTabClick.bind(this);
  }

  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

    if (!this.tabs.length) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', this.handleTabClick);
    });

    const initialTab = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || this.tabs[0];
    this.selectTab(initialTab, false);
  }

  disconnectedCallback() {
    this.tabs?.forEach((tab) => {
      tab.removeEventListener('click', this.handleTabClick);
    });
  }

  handleTabClick(event) {
    event.preventDefault();
    event.stopPropagation();

    this.selectTab(event.currentTarget);
  }

  selectTab(tab, focusTab = true) {
    if (!tab) return;

    const panelId = tab.getAttribute('aria-controls');
    if (!panelId) return;

    this.tabs.forEach((item) => {
      const isSelected = item === tab;
      item.setAttribute('aria-selected', isSelected);
      item.setAttribute('tabindex', isSelected ? '0' : '-1');
      item.classList.toggle('is-active', isSelected);
    });

    this.panels.forEach((panel) => {
      const isVisible = panel.id === panelId;
      panel.hidden = !isVisible;
      panel.classList.toggle('is-active', isVisible);
    });
  }
}

if (!customElements.get('menu-tabs')) {
  customElements.define('menu-tabs', MenuTabs);
}
